import { render, staticRenderFns } from "./unfinished-loan.vue?vue&type=template&id=c1e2de10&scoped=true"
import script from "./unfinished-loan.vue?vue&type=script&lang=js"
export * from "./unfinished-loan.vue?vue&type=script&lang=js"
import style0 from "./unfinished-loan.vue?vue&type=style&index=0&id=c1e2de10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e2de10",
  null
  
)

export default component.exports